import React from 'react';
import { Form } from '../../../components/form/Form';
import { useFormSubmit } from '../../../controllers/useSubmitForm';

export const BlogsForm = props => {
  const {
    route: { params },
  } = props;
  const { row, website } = params;
  let { onSubmit } = useFormSubmit({
    uri: '/blogmodels',
    eventSourceId: 'blog',
  });
  return (
    <Form
      api={`/blogmodels/${row?._id}`}
      fields={{
        keyword: 1,
        time: 1,
        image: 1,
        title: 1,
        description: 1,
        index: 1,
        tags: 1,
        is_published: 1,
      }}
      defaultValues={{
        website,
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'Keyword',
          type: 'text',
          field: 'keyword',
        },
        {
          label: 'Title',
          type: 'textArea',
          field: 'title',
        },
        {
          label: 'Description',
          type: 'textArea',
          field: 'description',
        },
        {
          label: 'Tags',
          type: 'multiText',
          field: 'tags',
        },
        {
          label: 'Time to Read',
          type: 'text',
          field: 'time',
        },
        {
          label: 'Index',
          type: 'number',
          field: 'index',
        },
        {
          field: 'image',
          type: 'file',
          label: 'Image',
          required: true,
        },
        {
          field: 'is_published',
          type: 'checkbox',
          label: 'Publish',
        },
      ]}
      {...props}
    />
  );
};

export const AddBlogsForm = props => {
  return <BlogsForm header="Add Blog" {...props} />;
};

export const UpdateBlogsForm = props => {
  return (
    <BlogsForm mode="edit" header="Update Blog" {...props} />
  );
};
